import { render } from "./AddQuickIssue.vue?vue&type=template&id=5aea5a4c&scoped=true"
import script from "./AddQuickIssue.vue?vue&type=script&lang=js"
export * from "./AddQuickIssue.vue?vue&type=script&lang=js"

import "./AddQuickIssue.vue?vue&type=style&index=0&id=5aea5a4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aea5a4c"]])

export default __exports__